import { denormalize } from "normalizr";
import { get } from "lodash";
import { factoringProfile } from "../../../api/schema";

const getFactorClient = state => {
  try {
    const item = get(state, "factoringClient.id");
    const user = get(state, "factoringClient.user");
    const denormalized = denormalize(
      { item },
      { item: factoringProfile },
      state.entities
    );

    if (user) {
      return {...denormalized.item, user} || {};
    } else {
      return denormalized.item || {};
    }
  } catch (err) {
    return {};
  }
};

export default getFactorClient;
